import {DayOfWeek, LocalDate} from '@js-joda/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import InlineLoadingIndicator from '@tracker/shared/src/LoadingIndicator/InlineLoadingIndicator';
import {useProjects} from '@tracker/shared/src/Projects/ProjectsProvider';
import {ClientServiceTeam, Employee} from '@tracker/shared/src/Scheduling/Utils/EmployeeSchedulesCompiler';
import React, {useState} from 'react';
import ScheduleFilter, {FilterSearch} from './ScheduleFilter';
import ScheduleList from './ScheduleList';

const useStyles = makeStyles(theme => ({
    filter: {
        marginBottom: theme.spacing(2),
    },
}));

type Props = {

    employees : Employee[] | null;
    filtersActive : boolean;
    teams : ClientServiceTeam[];
};

const Schedule : React.FC<Props> = ({employees, filtersActive, teams} : Props) => {
    const {projectsWithAllStatuses} = useProjects();
    const classes = useStyles();
    const [startDate, setStartDate] = useState(() => {
        const date = LocalDate.now();

        if (date.dayOfWeek() === DayOfWeek.SUNDAY) {
            return date.minusDays(7);
        }

        return date.minusDays(date.dayOfWeek().value() + 7);
    });
    const [filterSearch, setFilterSearch] = useState<FilterSearch>({query: '', type: 'people'});

    const loadingValue = (projectsWithAllStatuses ? 1 : 0) + (employees ? 1 : 0);

    return (
        <>
            <ScheduleFilter
                className={classes.filter}
                startDate={startDate}
                onStartDateChange={setStartDate}
                filterSearch={filterSearch}
                onFilterSearchChange={setFilterSearch}
            />

            {!projectsWithAllStatuses || !employees ? (
                <InlineLoadingIndicator
                    variant={loadingValue === 0 ? 'indeterminate' : 'determinate'}
                    value={loadingValue / 3 * 100}
                />
            ) : (
                <ScheduleList
                    startDate={startDate}
                    filterSearch={filterSearch}
                    projects={projectsWithAllStatuses}
                    employees={employees}
                    filtersActive={filtersActive}
                    teams={teams}
                    
                />
            )}
        </>
    )
};

export default Schedule;
